import * as React from "react";
import "./movieItemViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
import { MoviePoster } from "./MoviePoster";
export var ContinueWatchingItemView = function (_a) {
    var watchHistory = _a.watchHistory, movie = _a.movie, onMoviePress = _a.onMoviePress, focusRaw = _a.focusRaw;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onMoviePress(movie); },
    });
    return (React.createElement("div", { ref: ref, tabIndex: 0, className: "movie-card-container" },
        React.createElement(MoviePoster, { url: movie.poster }),
        React.createElement("p", { className: "rating" }, movie.mpaaRating),
        React.createElement("div", { className: "movie-progress-container" },
            React.createElement("p", { className: "continue-watching-movie-title" }, movie.name),
            React.createElement("div", { className: "progress-box" },
                React.createElement("div", { className: "bar", style: "width: " + (watchHistory.progress > 0.05 ? watchHistory.progress * 100 : 5) + "%" })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/ContinueWatchingItemView.tsx
// module id = 145
// module chunks = 1